var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1193 10.9998C11.4328 10.1087 12.0516 9.35731 12.866 8.87868C13.6804 8.40005 14.6379 8.22509 15.5689 8.38479C16.5 8.54449 17.3444 9.02854 17.9528 9.75121C18.5611 10.4739 18.8941 11.3885 18.8927 12.3332C18.8927 14.9998 14.8927 16.3332 14.8927 16.3332M14.9993 21.6665H15.0127M28.3327 14.9998C28.3327 22.3636 22.3631 28.3332 14.9993 28.3332C7.63555 28.3332 1.66602 22.3636 1.66602 14.9998C1.66602 7.63604 7.63555 1.6665 14.9993 1.6665C22.3631 1.6665 28.3327 7.63604 28.3327 14.9998Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.9da3c2b03cfd3cbce10556acdb2fe709.svg";
export { ForwardRef as ReactComponent };